import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";

import CourseMenuActions from "../../menuActions/CourseActions";
import CourseActions from "../Actions/CourseActions";
import CourseDetails from "../Details/CourseDetails";
import DefaultScoreView from "./DefaultScoreView";

export default function CourseView({ row, className, hideButton = false }) {
	const history = useHistory();

	const onPrimary = () => {
		history.push(generatePath(routing.paths.course, { id: row.id }));
	};

	return (
		<DefaultScoreView
			className={className}
			row={row}
			data-test-id="course-list-item"
			data-course-id={row.id}
			Details={<CourseDetails className="mr-12" row={row} />}
			Actions={
				!hideButton && (
					<CourseActions
						row={row}
						menuActions={<CourseMenuActions row={row} />}
						onPrimary={onPrimary}
					/>
				)
			}
		/>
	);
}
